import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

const APP_PREFIX = 'DOTTNET-';

@Injectable({
	providedIn: 'root'
})
export class LocalStorageService {
	constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

	setItem(key: string, value: any) {
		if (!isPlatformBrowser(this.platformId)) return;
		// Never persist `undefined`: JSON.stringify(undefined) is the JS value
		// undefined, which localStorage coerces to the poison string "undefined".
		if (value === undefined) {
			localStorage.removeItem(`${APP_PREFIX}${key}`);
			return;
		}
		localStorage.setItem(`${APP_PREFIX}${key}`, JSON.stringify(value));
	}

	getItem(key: string) {
		if (!isPlatformBrowser(this.platformId)) return null;
		const raw = localStorage.getItem(`${APP_PREFIX}${key}`);
		// Missing key, or a legacy poisoned "undefined" entry → null, never undefined.
		if (raw === null || raw === 'undefined') return null;
		return JSON.parse(raw);
	}

	removeItem(key: string) {
		if (isPlatformBrowser(this.platformId)) {
			localStorage.removeItem(`${APP_PREFIX}${key}`);
		}
	}

	deleteStorageStartingWith(prefix: string) {
		if (isPlatformBrowser(this.platformId)) {
			const keys = Object.keys(localStorage);
			let i = keys.length;

			while (i--) {
				if (keys[i].startsWith(prefix)) {
					localStorage.removeItem(keys[i]);
				}
			}
		}
		return;
	}
}
